/* =================================================================
   Curated product copy.

   Two reasons this exists rather than reading Shopify's description:

   1. The stored descriptions are inconsistent. Some are written the way the
      rest of the site reads; others are emoji-led sales copy ("🌴 - A
      Tropical Digestive Delight!"). Same page, two different brands.

   2. The stored ingredient sentence is a regulatory statement, not a list of
      what is in the bowl. Parsing it yields things like "Confectionery",
      which is a category, not an ingredient anyone wants to read.

   So display copy lives here and the legal statement stays where it belongs -
   verbatim, under "Full ingredient statement", straight from Shopify.

   `ing` is the FSSAI-declared ingredient set for each blend, taken from the
   product pages that were written against the packs themselves. Nothing goes
   in this list that is not on the label.
================================================================= */
window.WELLUBIA_COPY = {
  'supreme-5-in-1': {
    lede: 'Five blends in one jar',
    prose: 'Fennel, coriander, cardamom and mint layered together, so one jar covers the range of what a table reaches for after a meal.',
    ing: ['Fennel', 'Coriander', 'Cardamom', 'Mint']
  },
  'cardamom-fennel': {
    lede: 'The classic pairing, kept simple',
    prose: 'Cardamom over fennel with a light sugar coat. The most familiar after-meal combination in an Indian home, and the one most people start with.',
    ing: ['Fennel seeds', 'Dhana dal (roasted split coriander seeds)', 'Cardamom', 'Sugar', 'Spices']
  },
  'rose-mintiz': {
    lede: 'Rose and mint in a soft, refreshing blend',
    prose: 'Romantic floral notes of rose blended with refreshing mint. Sweet, aromatic and cooling, a mouth freshener with a hint of elegance.',
    ing: ['Fennel seeds', 'Sesame seeds', 'Amaranth', 'Amla', 'Dry dates', 'Rose petal', 'Dhana dal (roasted split coriander seeds)']
  },
  'playful-minty-fennel': {
    lede: 'A nostalgic mix, coloured naturally',
    prose: 'A minty-sweet medley of fennel seeds in soft colours. Familiar to anyone who grew up reaching into the bowl by the door.',
    ing: ['Fennel seeds', 'Sugar', 'Mint']
  },
  'jammu-mix': {
    lede: 'Northern flavour, gently sweet',
    prose: 'Fennel and coriander with dry dates and amla, in the northern style, a little sweeter, a little softer than the western mixes.',
    ing: ['Fennel seeds', 'Amaranth', 'Dry dates', 'Amla', 'Dhana dal (roasted split coriander seeds)', 'Watermelon seeds']
  },
  'in-flight-freshener': {
    lede: 'Made for long journeys',
    prose: 'A light, low-sugar mix for after airline food or a long drive. Small enough for a cabin bag and mild enough to chew slowly.',
    ing: ['Fennel seeds', 'Sesame seeds', 'Amaranth', 'Dhana dal (roasted split coriander seeds)', 'Spice extract']
  },
  'fennel-minitz': {
    lede: 'Sugar-coated fennel, nothing else',
    prose: 'Compact bites of fennel under a thin sugar shell. Crunch first, then the cooling seed underneath.',
    ing: ['Fennel seeds', 'Sugar']
  },
  'evergreen-mix': {
    lede: 'Subtly sweet, quietly freshening',
    prose: 'Fennel, sesame and dhana dal with amaranth and coconut. The everyday mix, the one that stays on the table rather than in the cupboard.',
    ing: ['Fennel seeds', 'Sesame seeds', 'Dhana dal (roasted split coriander seeds)', 'Amaranth', 'Desiccated coconut']
  },
  'sadabahar-pan': {
    lede: 'The paan tradition, without the leaf',
    prose: 'A meetha dry-paan mukhwas with dry dates, fennel, betel leaf, amla and rose. Made for the small pinch served after a meal.',
    ing: ['Dry dates', 'Fennel seeds', 'Betel leaves', 'Amla', 'Rose petal paste', 'Spice extract']
  },
  'anaardana-shots': {
    lede: 'Tangy, juicy, nostalgic',
    prose: 'Sun-dried pomegranate with cumin and dry mango. Sharp and sour first, then the salt, the taste of a school-gate churan.',
    ing: ['Rose petal paste', 'Pomegranate powder', 'Dhana dal (roasted split coriander seeds)', 'Dry mango', 'Cumin', 'White pepper', 'Clove', 'Black salt']
  },
  'cumin-nibbles': {
    lede: 'Cumin, roasted and salted',
    prose: 'Cumin and dhana dal with dry mango and black salt. Savoury rather than sweet, for a meal that was already rich.',
    ing: ['Rose petal paste', 'Cumin', 'Dhana dal (roasted split coriander seeds)', 'Dry mango', 'White pepper', 'Clove', 'Black salt']
  },
  'mocktail-shots': {
    lede: 'Sharp, cooling, faintly sweet',
    prose: 'Rose and cumin with dry mango and cassia. Bright at the front and slow to fade, the way a good drink finishes.',
    ing: ['Rose petal paste', 'Cumin', 'Dhana dal (roasted split coriander seeds)', 'Dry mango', 'Black pepper', 'Cassia', 'Clove', 'Black salt']
  },
  'mango-fun': {
    lede: 'Dried mango with a savoury edge',
    prose: 'Ripe mango pulp dried and folded with cumin and black salt. Sweet, then sour, then salty, in that order.',
    ing: ['Dried ripe mango pulp', 'Cumin', 'Black pepper', 'Cassia', 'Black salt']
  },
  'tamarind-candies': {
    lede: 'Tamarind, set into a soft candy',
    prose: 'Pure tamarind pulp with a light sugar set. Dark and tangy, closer to the fruit than to a sweet.',
    ing: ['Tamarind pulp', 'Sugar', 'Tamarind flavour']
  },
  'omega-mix': {
    lede: 'A crisp, savoury mix of familiar seeds',
    prose: 'Flax, pumpkin and watermelon seeds, roasted and left unsweetened. A spoonful after a meal, or over anything you are already eating.',
    ing: ['Flax', 'Pumpkin', 'Watermelon seeds']
  },
  'nutri-seeds': {
    lede: 'A seed mix that earns its place',
    prose: 'Fennel, dill and sesame with ajwain and rock salt. Savoury, unsweetened, and easy to keep reaching for.',
    ing: ['Fennel seeds', 'Dhana dal (roasted split coriander seeds)', 'Dill seeds', 'Sesame seeds', 'Ajwain', 'Rock salt']
  },
  'flax-seed-mukhwas': {
    lede: 'Flax, sesame and dry mango',
    prose: 'Roasted flax and sesame with dhana dal and a little dry mango. Nutty at the base, tangy at the finish.',
    ing: ['Flax seeds', 'Sesame seeds', 'Dhana dal (roasted split coriander seeds)', 'Dry mango', 'Spices', 'Salt']
  },
  'crunchy-coriander-splitz': {
    lede: 'Split coriander, salted',
    prose: 'Coriander seed split and lightly salted. One ingredient, done properly, crunch and a clean citrus warmth.',
    ing: ['Dhana dal (roasted split coriander seeds)', 'Rock salt']
  },
  '1-sadabahaar-paan-gift-box': {
    lede: 'Eight packs, one paan tradition',
    prose: 'A curated box across the paan range, sealed and ready to give. Made for Diwali lists, house-warmings and the thank you that should not be flowers again.'
  },
  'wellubia-gift-hamper': {
    lede: 'The finishing touch for a pack of four or more',
    prose: 'Unlock The Mehfil Potli by Wellubia for ₹59 when your custom pack reaches four bottles. Its velvet finish holds your Wellubia bottles beautifully, then stays useful for jewellery, keepsakes or anything worth carrying with care.'
  }
};
